import React, { useState } from "react";
import emailjs from "emailjs-com";
import Modal from "./Modal"; // Zorg ervoor dat je de aangepaste Modal gebruikt
import { useNavigate } from "react-router-dom";

const ConfirmationPage = ({ onNext, onBack, formData: initialFormData }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const selectedInsurance = initialFormData.selectedInsurance || {};

  const handleConfirm = () => {
    // Verzenden van e-mail
    sendEmail();
  };

  const sendEmail = () => {
    // Motorinformatie formatteren
    const motorInfo = initialFormData.motorPower
      .map(
        (power, index) =>
          `Motor ${index + 1}: 
        - Vermogen: ${power} PK/kW
        - Serienummer: ${initialFormData.motorSerial[index] || "Niet ingevuld"}
        - Motortype: ${initialFormData.motorType[index] || "Niet ingevuld"}
        - Brandstof: ${initialFormData.fuelType[index] || "Niet ingevuld"}`
      )
      .join("\n\n"); // Nieuwe regel tussen motoren

    // Schadegevallen formatteren
    const accidentInfo = initialFormData.accidentDetails.length
      ? initialFormData.accidentDetails
          .map(
            (accident, index) =>
              `Schadegeval ${index + 1}:
            - Naam vaartuig: ${accident.boatName || "Niet ingevuld"}
            - Datum: ${accident.date || "Niet ingevuld"}
            - Omstandigheden: ${accident.circumstances || "Niet ingevuld"}
            - Kosten: €${accident.costs || "Niet ingevuld"}`
          )
          .join("\n\n")
      : "Geen schadegevallen in de laatste 5 jaar.";

    const templateParams = {
      boatType: initialFormData.boatType || "Niet ingevuld",
      boatLength: initialFormData.boatLength || "Niet ingevuld",
      countryFlag: initialFormData.countryFlag || "Niet ingevuld",
      boatLocation: initialFormData.boatLocation || "Niet ingevuld",
      boatRegion: initialFormData.boatRegion.join(", ") || "Niet ingevuld",
      boatBrand: initialFormData.boatBrand || "Niet ingevuld",
      boatYear: initialFormData.boatYear || "Niet ingevuld",
      motorCount: initialFormData.motorCount || "Niet ingevuld",
      motorInfo, // Geformatteerde motorinformatie
      accidentInfo, // Geformatteerde schadegevallen

      name: initialFormData.name || "Niet ingevuld",
      surname: initialFormData.surname || "Niet ingevuld",
      street: initialFormData.street || "Niet ingevuld",
      houseNumber: initialFormData.houseNumber || "Niet ingevuld",
      postalCode: initialFormData.postalCode || "Niet ingevuld",
      country: initialFormData.country || "Niet ingevuld",
      birthdate: initialFormData.birthdate || "Niet ingevuld",
      phoneNumber: initialFormData.phoneNumber || "Niet ingevuld",
      email: initialFormData.email || "Niet ingevuld",

      liability: selectedInsurance.liability ? "Ja" : "Nee",
      waterSkiing: selectedInsurance.waterSkiing ? "Ja" : "Nee",
      casco: selectedInsurance.casco ? "Ja" : "Nee",
      cascoValue: selectedInsurance.cascoValue || "Niet ingevuld",
      rescueCosts: selectedInsurance.rescueCosts ? "Ja" : "Nee",
      rescueAmount: selectedInsurance.rescueAmount || "Niet ingevuld",
      personalAccidents: selectedInsurance.personalAccidents ? "Ja" : "Nee",
      accidentPassengers:
        selectedInsurance.accidentPassengers || "Niet ingevuld",
      legalAssistance: selectedInsurance.legalAssistance ? "Ja" : "Nee",
    };

    emailjs
      .send(
        "service_o5939qw",
        "template_yjybnap",
        templateParams,
        "Mq0NNULbOl3aTvHgz"
      )
      .then(
        () => {
          setShowModal(true);
        },
        (error) => {
          console.error("Er is een fout opgetreden:", error);
          alert("Er ging iets mis bij het verzenden van de e-mail.");
        }
      );
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/");
  };

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack(initialFormData);
    }
  };

  return (
    <div className="p-8">
      <div className="mx-auto max-w-3xl p-6">
        <h1 className="text-3xl font-semibold mb-6 text-left text-[#1a2a6c]">
          Bevestig je gegevens
        </h1>
        <p className="text-lg font-medium text-[#1a2a6c] mb-6">
          Overloop nog even je gegevens zodat we voor jou aan de slag kunnen
          gaan. Een foutje gevonden? Geen probleem, je kan je gegevens nog
          wijzigen.
        </p>

        {/* Bootinformatie */}
        <div className="space-y-4 mb-8">
          <h2 className="text-xl font-semibold text-[#1a2a6c]">
            Bootinformatie
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
            <p>
              <strong>Boottype:</strong> {initialFormData.boatType}
            </p>
            <p>
              <strong>Bootlengte:</strong> {initialFormData.boatLength} meter
            </p>
            <p>
              <strong>Land van registratie:</strong>{" "}
              {initialFormData.countryFlag}
            </p>
            <p>
              <strong>Ligplaats:</strong> {initialFormData.boatLocation}
            </p>
            <p>
              <strong>Vaargebied:</strong>{" "}
              {initialFormData.boatRegion.join(", ")}
            </p>
            <p>
              <strong>Merk:</strong> {initialFormData.boatBrand}
            </p>
            <p>
              <strong>Bouwjaar:</strong> {initialFormData.boatYear}
            </p>
            <p>
              <strong>Aantal motoren:</strong> {initialFormData.motorCount}
            </p>

            {initialFormData.motorPower.map((power, index) => (
              <p key={index}>
                <strong>Motor {index + 1} vermogen:</strong> {power} PK/kW
              </p>
            ))}

            {initialFormData.motorSerial.map((serial, index) => (
              <p key={index}>
                <strong>Motor {index + 1} serienummer:</strong> {serial}
              </p>
            ))}
          </div>
        </div>

        {/* Eigenaarinformatie */}
        <div className="space-y-4 mb-8">
          <h2 className="text-xl font-semibold text-[#1a2a6c]">
            Eigenaarinformatie
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
            <p>
              <strong>Naam:</strong> {initialFormData.name}
            </p>
            <p>
              <strong>Voornaam:</strong> {initialFormData.surname}
            </p>
            <p>
              <strong>Straat:</strong> {initialFormData.street}
            </p>
            <p>
              <strong>Nummer:</strong> {initialFormData.houseNumber}
            </p>
            <p>
              <strong>Postcode:</strong> {initialFormData.postalCode}
            </p>
            <p>
              <strong>Land:</strong> {initialFormData.country}
            </p>
            <p>
              <strong>Geboortedatum:</strong> {initialFormData.birthdate}
            </p>
            <p>
              <strong>Telefoonnummer:</strong> {initialFormData.phoneNumber}
            </p>
            <p>
              <strong>Email:</strong> {initialFormData.email}
            </p>
            {initialFormData.isLegalEntity && (
              <p>
                <strong>Ondernemingsnummer:</strong>{" "}
                {initialFormData.enterpriseNumber}
              </p>
            )}
          </div>
        </div>

        {/* Schadegevallen */}
        {initialFormData.noAccidents &&
          initialFormData.accidentDetails.length > 0 && (
            <div className="space-y-4 mb-8">
              <h2 className="text-xl font-semibold text-[#1a2a6c]">
                Schadegevallen
              </h2>
              {initialFormData.accidentDetails.map((accident, index) => (
                <div
                  key={index}
                  className="border rounded-md p-4 border-[#ff6f61] space-y-2"
                >
                  <p>
                    <strong>Naam vaartuig:</strong> {accident.boatName}
                  </p>
                  <p>
                    <strong>Datum van het ongeval:</strong> {accident.date}
                  </p>
                  <p>
                    <strong>Omstandigheden:</strong> {accident.circumstances}
                  </p>
                  <p>
                    <strong>Kosten:</strong> €{accident.costs}
                  </p>
                </div>
              ))}
            </div>
          )}
        {/* Verzekeringsopties */}
        <div className="space-y-4 mb-8">
          <h2 className="text-xl font-semibold text-[#1a2a6c]">
            Verzekeringsopties
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
            <p>
              <strong>Burgerlijke aansprakelijkheid:</strong>{" "}
              {selectedInsurance.liability ? "Ja" : "Nee"}
            </p>
            {selectedInsurance.waterSkiing && (
              <p>
                <strong>Waterskiën verzekerd:</strong> Ja
              </p>
            )}
            {selectedInsurance.casco && (
              <>
                <p>
                  <strong>Casco verzekering:</strong> Ja
                </p>
                <p>
                  <strong>Casco waarde:</strong> €{selectedInsurance.cascoValue}
                </p>
              </>
            )}
            {selectedInsurance.rescueCosts && (
              <>
                <p>
                  <strong>Lichtingskosten:</strong> Ja
                </p>
                <p>
                  <strong>Bedrag lichtingskosten:</strong>{" "}
                  {selectedInsurance.rescueAmount === "custom"
                    ? "Op aanvraag"
                    : `€ ${selectedInsurance.rescueAmount}`}
                </p>
              </>
            )}
            {selectedInsurance.personalAccidents && (
              <>
                <p>
                  <strong>Persoonlijke ongevallen:</strong> Ja
                </p>
                <p>
                  <strong>Aantal passagiers:</strong>{" "}
                  {selectedInsurance.accidentPassengers}
                </p>
              </>
            )}
            <p>
              <strong>Rechtsbijstand:</strong>{" "}
              {selectedInsurance.legalAssistance ? "Ja" : "Nee"}
            </p>
          </div>
        </div>

        {/* Navigatieknoppen */}
        <div className="flex justify-between mt-6 gap-4">
          <button
            type="button"
            onClick={handleBack}
            className="py-2 px-4 bg-[#1a2a6c] text-[#ff6f61] rounded-md text-sm font-medium hover:bg-[#142057]"
          >
            Gegevens wijzigen?
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="py-2 px-4 bg-[#1a2a6c] text-[#ff6f61] rounded-md text-sm font-medium hover:bg-[#142057]"
          >
            Bevestig hier je gegevens
          </button>
        </div>
      </div>

      {/* Modal voor bevestiging */}
      <Modal show={showModal} onClose={handleCloseModal} />
    </div>
  );
};

export default ConfirmationPage;
